import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=a35b88c8&scoped=true&"
import script from "./Accepted.vue?vue&type=script&lang=js&"
export * from "./Accepted.vue?vue&type=script&lang=js&"
import style0 from "./Accepted.vue?vue&type=style&index=0&id=a35b88c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b88c8",
  null
  
)

export default component.exports